import axios from "axios";

/**
 * Função para fazer requisição do tipo GET
 * @param {string} url Url no qual que servir para fazer a requisição,
 * @param {headers} headers  Um objeto javaScript, com todos os headers que deseja ser enviados.
 */
export const receber = (url, headers) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url: url,
      headers: headers,
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

/**
 * Função para fazer requisição do tipo POST
 * @param url Url no qual que servir para fazer a requisição,
 * @param headers Um objeto javaScript, com todos os headers que deseja ser enviados.
 * @param datas Um objeto javaScript, com todos os dados solicitados.
 */
export const enviar = (url, headers, datas) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: url,
      headers: headers,
      data: datas,
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

/** Função para fazer requisição do tipo PUT
 * @param {string} url: Url no qual que servir para fazer a requisição,
 * @param {object} headers Um objeto javaScript, com todos os headers que deseja ser enviados.
 * @param {object} datas Um objeto javaScript, com todos os dados solicitados.
 */
export const editar = (url, headers, datas) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "put",
      url: url,
      headers: headers,
      data: datas,
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

/**
 * Função para fazer requisições do tipo DELETE
 * @param {String} url
 * @param {Object} headers
 */
export const apagar = (url, headers) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "delete",
      url: url,
      headers: headers,
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const atualizarParcialmente = (url, headers) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "patch",
      url: url,
      headers: headers,
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};
